"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelActions = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const PanelActionButton_1 = require("./PanelActionButton");
require("./types");
const PanelActions = ({ actions, loading }) => (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.m, align: components_1.STACK_ALIGN.center }, actions.map((props) => (react_1.default.createElement(PanelActionButton_1.PanelActionButton, Object.assign({ key: props.id || props.text }, props, { loading: loading }))))));
exports.PanelActions = PanelActions;
exports.PanelActions.displayName = 'PanelActions';
//# sourceMappingURL=PanelActions.js.map